import { render, staticRenderFns } from "./PaletteEdit.vue?vue&type=template&id=e05c3f0e"
import script from "./PaletteEdit.vue?vue&type=script&lang=js"
export * from "./PaletteEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports